
// import { Button, Card, Image, Skeleton, Tooltip,Modal } from 'antd';
// import React, { useContext } from 'react';
// import { useParams } from 'react-router-dom';
// import useWallpaper from '../../util/useWallpaper';
// import { DownloadOutlined } from '@ant-design/icons';
// import { AuthContext } from '../../context/auth';

// function Wallpaper(props) {
//   const { user } = useContext(AuthContext);
//   const { id } = useParams();
//   const { data, loading, error } = useWallpaper(id);

//   if (error) return <div>Something went wrong!</div>;
//   if (loading)
//     return (
//       <div className="d-flex justify-content-center">
//         <Skeleton active />
//       </div>
//     );

  // const download = async () => {
  //   const originalImage = `${data.getWallpaper.image}`;
  //   const image = await fetch(originalImage);

  //   const nameSplit = originalImage.split('/');
  //   const duplicateName = nameSplit.pop();

  //   const imageBlob = await image.blob();
  //   const imageURL = URL.createObjectURL(imageBlob);
  //   const link = document.createElement('a');
  //   link.href = imageURL;
  //   link.download = duplicateName;
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // };

//   return (
   
//     <div className="container d-flex flex-column align-items-center">
//       <Card className="mt-5" style={{ width: '100%', maxWidth: '700px' }}>
//         <Card.Meta title={`${data.getWallpaper.title} - ${data.getWallpaper.category}`} />
//         <Image
//           className="img"
//           src={data.getWallpaper.image}
//           alt="wallpaper"
//           style={{ maxWidth: '100%', marginTop: '15px' }}
//         />
//         <Card.Meta title="Description" />
//         <Card.Meta description={data.getWallpaper.description} />
//         <Card.Meta title="Uploaded By" />
//         <Card.Meta description={data.getWallpaper.username} />
//         {user ? (
//           <Button
//             className="mt-3"
//             onClick={download}
//             type="primary"
//             shape="round"
//             icon={<DownloadOutlined />}
//             size="large"
//           >
//             Free Download
//           </Button>
//         ) : (
//           <Tooltip title="Login To Download">
//             <Button
//               className="mt-3"
//               disabled
//               type="primary"
//               shape="round"
//               icon={<DownloadOutlined />}
//               size="large"
//             >
//               Free Download
//             </Button>
//           </Tooltip>
//         )}
//       </Card>
//     </div>
    
//   );
// }

// export default Wallpaper;


import { Button, Card, Image, Tooltip,Skeleton } from 'antd';
import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import useWallpaper from '../../util/useWallpaper';
import { DownloadOutlined } from '@ant-design/icons';
import { AuthContext } from '../../context/auth';

function Wallpaper(props) {
  const { user } = useContext(AuthContext);
  const { id } = useParams();
  const { data, loading, error } = useWallpaper(id);

  const Content = () => {
    if (error) return <div>Something went wrong!</div>;
    return (
      <>
        <Card.Meta title={`${data.getWallpaper.title} - ${data.getWallpaper.category}`} />
        <Image
          className="img"
          src={data.getWallpaper.image}
          alt="wallpaper"
          style={{ maxWidth: '100%', marginTop: '15px' }}
        />
        <Card.Meta title="Description" />
        <Card.Meta description={data.getWallpaper.description} />
        <Card.Meta title="Uploaded By" />
        <Card.Meta description={data.getWallpaper.username} />
        {user ? (
          <Button
            className="mt-3"
            onClick={download}
            type="primary"
            shape="round"
            icon={<DownloadOutlined />}
            size="large"
          >
            Free Download
          </Button>
        ) : (
          <Tooltip title="Login To Download">
            <Button
              className="mt-3"
              disabled
              type="primary"
              shape="round"
              icon={<DownloadOutlined />}
              size="large"
            >
              Free Download
            </Button>
          </Tooltip>
        )}
      </>
    );
  };

  const download = async () => {
    const originalImage = `${data.getWallpaper.image}`;
    const image = await fetch(originalImage);

    const nameSplit = originalImage.split('/');
    const duplicateName = nameSplit.pop();

    const imageBlob = await image.blob();
    const imageURL = URL.createObjectURL(imageBlob);
    const link = document.createElement('a');
    link.href = imageURL;
    link.download = duplicateName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="container d-flex flex-column align-items-center">
      <Card className="mt-5" style={{ width: '100%', maxWidth: '700px' }}>
        {loading ? (
          <Skeleton active />
        ) : (
          Content()
        )}
      </Card>
    </div>
  );
}

export default Wallpaper;

